import styled from "styled-components";
import {
  colors,
  spacing,
  radius,
  textStyles,
  toCSS
} from "design-system/foundation";
import { breakpoints, zIndex } from "styles";

export type ModalSize = "sm" | "md" | "lg";

const modalWidths: Record<ModalSize, string> = {
  sm: "480px",
  md: "560px",
  lg: "640px"
};

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: ${zIndex.modal};
`;

export const ModalContainer = styled.div<{ $size: ModalSize }>`
  &,
  & *,
  & *::before,
  & *::after {
    box-sizing: border-box;
  }

  display: flex;
  flex-direction: column;
  gap: ${spacing["5xl"]};
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${zIndex.modal + 1};
  background-color: ${colors.bg.base.default};
  border-radius: ${radius.lg} ${radius.lg} 0 0;
  padding: ${spacing["5xl"]} ${spacing.none} ${spacing["2xl"]};
  max-height: 640px;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(24, 24, 37, 0.15);

  @media ${breakpoints.tablet} {
    top: 50%;
    bottom: unset;
    left: 50%;
    right: unset;
    transform: translate(-50%, -50%);
    width: ${({ $size }) => modalWidths[$size]};
    height: auto;
    border-radius: ${radius.xl};
    padding: ${spacing["5xl"]};
    max-height: 600px;
  }
`;

export const ModalHeader = styled.div<{
  $hasHeading: boolean;
  $sticky: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: ${({ $hasHeading }) =>
    $hasHeading ? "space-between" : "flex-end"};
  flex-shrink: 0;
  padding: ${spacing.none} ${spacing["2xl"]};

  ${({ $sticky }) =>
    $sticky &&
    `
      position: sticky;
      top: 0;
      z-index: 1;
      width: 100%;
      background-color: ${colors.bg.base.default};
    `}

  @media ${breakpoints.tablet} {
    padding: ${spacing.none};

    ${({ $sticky }) => $sticky && "position: static;"}
  }
`;

export const ModalHeading = styled.h2`
  margin: ${spacing.none};
  ${toCSS(textStyles.heading.h6)};
  color: ${colors.text.base.primary};
`;

export const CloseButton = styled.button`
  display: none;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: ${spacing.xs};

  .icon {
    display: flex;
    align-items: center;
    font-size: 20px;
    color: ${colors.icon.base.primary};
  }

  @media ${breakpoints.tablet} {
    display: flex;
  }
`;
